import PrimeVue from 'primevue/config';

export function configurePrimeVue(app) {
  app.use(PrimeVue, {
    pt: {
      calendar: {
        dateFormat: 'DD/MM/YYYY' 
      },
      global: {
        css: ``
      }
    },
    zIndex: {
      modal: 1100,
      overlay: 1000,
      menu: 1000,
      tooltip: 1100
    },
    ripple: true
  });
}